import { render, staticRenderFns } from "./Quality2.vue?vue&type=template&id=2a8cb806"
import script from "./Quality2.vue?vue&type=script&lang=js"
export * from "./Quality2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports